import { useState } from "react";
import { toast } from "react-toastify";
/**
 *
 * @param {*} apiFunc
 * @returns
 * data: request response
 * error: error if request failed
 * loading: request progress state
 * request: function to initiate the request
 */
export default function useApi(apiFunc) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  /**
   *
   * @param {*} args the params to send to server
   * @param {*} fireToast control showing toast or not
   * @param {*} onrequest text to show when request finish
   * @returns response from server
   */
  const request = async (args, fireToast = true, onrequest={}) => {
    setLoading(true);
    setError("");
    try {
      let result;
      if (fireToast) {
        result = await toast.promise(apiFunc(args), {
          pending: onrequest.pending || "Fetching data",//"Promise is pending",
          success: onrequest.success || "Data fetched successfully👌",//"Promise resolved 👌",
          error: onrequest.error || "Data fetch failed",//"Promise rejected 🤯",
        }); //toast.promise returns the promise itself, apiFunc here
      } else {
        result = await apiFunc(args);
      }

      setData(result.data);
      return result;
    } catch (err) {
      setError(err.message || "Unexpected Error!");
      return err.response;
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    error,
    loading,
    request,
  };
}
